import { atomWithCookieStorage } from '~shared/atoms/utils/cookieStorage';

export const languageAtom = atomWithCookieStorage('socrative_lang', 'en');
